import { useEffect, useRef } from 'react';
import './SlidingPanel.css';
import bulletIcon from '../assets/bullet.svg';

const SlidingPanel = () => {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const clone = track.innerHTML;
    track.innerHTML += clone;

    let position = 0;
    const speed = 0.5;

    const animate = () => {
      position -= speed;
      if (Math.abs(position) >= track.scrollWidth / 2) {
        position = 0;
      }
      track.style.transform = `translateX(${position}px)`;
      requestAnimationFrame(animate);
    };

    animate();
  }, []);

  return (
    <div className="sliding-panel">
      <div className="sliding-panel__track" ref={trackRef}>
        <span className="sliding-panel__item">
          <img src={bulletIcon} alt="" /> MAXIMUM PERFORMANCE
        </span>
        <span className="sliding-panel__item">
          <img src={bulletIcon} alt="" /> HIGHEST REVENUE
        </span>
        <span className="sliding-panel__item">
          <img src={bulletIcon} alt="" /> TRUSTED PARTNER
        </span>
        <span className="sliding-panel__item">
          <img src={bulletIcon} alt="" /> MAXIMUM PERFORMANCE
        </span>
        <span className="sliding-panel__item">
          <img src={bulletIcon} alt="" /> HIGHEST REVENUE
        </span>
        <span className="sliding-panel__item">
          <img src={bulletIcon} alt="" /> TRUSTED PARTNER
        </span>
      </div>
    </div>
  );
};

export default SlidingPanel;
